export const icons = [
	"add",
	"arrow-down",
	"arrow-left",
	"attachment",
	"calender",
	"case",
	"check",
	"close",
	"delete",
	"edit",
	"email",
	"excel",
	"grid",
	"location",
	"money",
	"person",
	"phone",
	"positive-review",
	"pr-sheet-shape-1",
	"pr-sheet-shape-10",
	"pr-sheet-shape-2",
	"pr-sheet-shape-3",
	"pr-sheet-shape-4",
	"pr-sheet-shape-5",
	"pr-sheet-shape-6",
	"pr-sheet-shape-7",
	"pr-sheet-shape-8",
	"pr-sheet-shape-9",
	"recent-time",
	"search",
	"users",
	"work"
] as const

export type IconType = (typeof icons)[number]